// TXI01 - Tax Type Code (DE 963), common codes used by the 810's TXI
// segment. Transcribed from
// reference/session/810-invoice-qualifiers-txt.md.

import type {CodeListEntry} from './types';

export const TAX_TYPE_CODES: CodeListEntry[] = [
  {code: 'ST', label: 'State Sales Tax'},
  {code: 'LS', label: 'State and Local Sales Tax'},
  {code: 'CT', label: 'County Tax'},
  {code: 'CP', label: 'County/Parish Sales Tax'},
  {
    code: 'LT',
    label:
      'Local Sales Tax (All Applicable Sales Taxes by Taxing Authority Below the State Level)',
  },
  {code: 'GS', label: 'Goods and Services Tax'},
  {code: 'TX', label: 'All Taxes'},
];
